import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import iconSenha from '../../../resources/img/icon-senha.svg';
import SideMenu from '../../../Components/SideMenu';
import Header from '../../../Components/Header';
import Redirect from '../../../Components/RedirectScreen';
import Loading from '../../../Components/LoaderScreen';
import Alert from '../../../Components/Alert';
import Table from '../../../Components/Table';
import Input from '../../../Components/Input';
import ApiService from '../../../Utils/services';
import Funcoes from '../../../Utils/functions';
import Paginacao from '../../../Components/Paginacao';
import Modal from '../../../Components/Modal';
import { dataBrMask } from '../../../Utils/mask';

// Ícones para cada tipo de operação
const operationIcons = {
    'Crédito': '💳',
    'Débito': '💳',
    'Boleto': '📄',
    'Pix': '⚡',
    'Transferência': '↔️',
    'Depósito': '⬇️',
    'Saque': '⬆️'
};

// Estilos para cada status de transação
const statusStyles = {
    0: { // Pendente
        backgroundColor: '#fff3cd',
        color: '#856404',
        borderColor: '#ffeeba'
    },
    1: { // Pago
        backgroundColor: '#d4edda',
        color: '#155724',
        borderColor: '#c3e6cb'
    },
    2: { // Cancelado
        backgroundColor: '#f8d7da',
        color: '#721c24',
        borderColor: '#f5c6cb'
    },
    3: { // Estornada
        backgroundColor: '#f8d7da',
        color: '#721c24',
        borderColor: '#f5c6cb'
    },
    4: { // Não Autorizada
        backgroundColor: '#f8d7da',
        color: '#721c24',
        borderColor: '#f5c6cb'
    },
    5: { // Em processamento
        backgroundColor: '#e2e3e5',
        color: '#383d41',
        borderColor: '#d6d8db'
    },
    default: { // Desconhecido
        backgroundColor: '#e2e3e5',
        color: '#383d41',
        borderColor: '#d6d8db'
    }
};

export default function CardStatementDetails(props) {

    const [redirect, setRedirect] = useState(false);
    const [path, setPath] = useState('');
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [alertType, setAlertType] = useState(2);
    const [transacao, setTransacao] = useState({});
    const [senha, setSenha] = useState('');

    const user = JSON.parse(sessionStorage.getItem("userData"));

    const status_transacao = ["Pendente", "Finalizada", "Cancelada", "Estornada", "Não Autorizada", "Em processamento"];
    const classe_transacao = ["grey", "green", "grey", "grey", "red", "grey"];
    const tipo_operacao = ["", "Débito", "Crédito", "Boleto", "Pix"];
    const bandeiras_nome = ["", "Visa", "Mastercard", "Diners", "Elo", "Amex", "Hipercard"];

    useEffect(() => {
        const id = props.location.state.id;
        carregaTransacao(id);
    }, []);

    const carregaTransacao = (id) => {
        setLoading(true);
        var url = 'transacao/transacao/' + id;
        ApiService.get(url, user.token)
            .then(result => {
                const response = result.data;
                const dados = [];
              
                var data = response.data.datahora.split(" ");
                var hora = data.length > 1 ? data[1] : '';
              
                var dataPagamento = response.data.datahora_pagto ? response.data.datahora_pagto.split(" ") : '';

                if (dataPagamento.length > 1) {
                    var horaPagamento = dataPagamento[1];
                } else {
                    var horaPagamento = '';
                }
                
                setTransacao({
                    id: response.data.id,
                    paymentid: response.data.paymentid,
                    tipo: tipo_operacao[response.data.tipo_operacao],
                    tipo_operacao_id: response.data.tipo_operacao,
                    data: Funcoes.data2Brazilian(data[0]),
                    hora: hora,
                    data_completa: Funcoes.data2Brazilian(data[0]) + ' ' + hora,
                    codref: response.data.codref || '-',
                    status: status_transacao[response.data.status],
                    status_id: response.data.status,
                    classe: classe_transacao[response.data.status],
                    final_cartao: response.data.finalcartao ? "**** "+response.data.finalcartao : null,
                    bandeira: response.data.bandeira || null,
                    bandeira_nome: bandeiras_nome[response.data.bandeira] || null,
                    nome_titular: response.data.nome_titular || null,
                    parcelamento: response.data.parcelas + "x",
                    parcelas: response.data.parcelas || 1,
                    valorbruto: response.data.valor,
                    taxas: response.data.taxas,
                    liquido: response.data.valor_liquido,
                    liberacao: Funcoes.data2Brazilian(response.data.data_liberacao),
                    pagamento: response.data.datahora_pagto ? Funcoes.data2Brazilian(dataPagamento[0]) + ' ' + horaPagamento : '-',
                    descricao: response.data.descricao || null,
                    cliente_nome: response.data.cliente_nome || null,
                    cliente_email: response.data.cliente_email || null,
                    cliente_documento: response.data.cliente_documento || null,
                    gateway: response.data.gateway || null,
                    nsu: response.data.nsu || null,
                    autorizacao: response.data.autorizacao || null
                });
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                const result = ApiService.handleErros(err.response);
                if (result.status === "unauthorized") {
                    sessionStorage.removeItem('userData');
                    setPath('/');
                }
                setLoading(false);
                setAlertText(result.response);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            })
    }

    const cancelar = () => {
        if(senha === ''){
            setAlertType(2);
            setAlertText("Preencha o campo senha corretamente");
            setAlert(true);
        }else{
     
            
            if(!transacao.paymentid) {
                setAlertType(2);
                setAlertText("Não foi possível cancelar: payment_id não encontrado na transação");
                setAlert(true);
                return;
            }
            
            setLoading(true);
            ApiService.post('transacao/cancelar', {
                payment_id: transacao.paymentid, 
                transacao_id: transacao.id, 
                senha: senha
            }, user.token)
                .then(result => {
                    const response = result.data;
                    setLoading(false);
                    setAlertType(1); 
                    setAlertText('Transação cancelada com sucesso.'); 
                    setModal(false); 
                    setAlert(true);
                })
                .catch(err => {
                    console.log(err);
                    const result = ApiService.handleErros(err.response);
                    if (result.status === "unauthorized") {
                        sessionStorage.removeItem('userData');
                        setPath('/');
                    }
                    setLoading(false);
                    setAlertText(result.response);
                    setTimeout(() => {
                        setAlert(true);
                    }, 300);
                })
        }
    }

    return (
        <>
            <Redirect redirect={redirect} path={path} />
            <Loading show={loading} />
            <Alert show={alert} texto={alertText} tipo={alertType} action={() => setAlert(false)} />
            <Modal show={modal} footer={<>
                    <button 
                        className="btn secondary" 
                        onClick={() => setModal(false)}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#f8f9fa',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            marginRight: '10px',
                            cursor: 'pointer'
                        }}
                    >
                        Cancelar
                    </button>
                    <button 
                        className="btn primary"
                        onClick={cancelar}
                        disabled={!senha}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: senha ? '#dc3545' : '#f8d7da',
                            color: senha ? 'white' : '#721c24',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: senha ? 'pointer' : 'not-allowed',
                            fontWeight: 'bold'
                        }}
                    >
                        <span style={{ marginRight: '5px' }}>✖</span> Confirmar Cancelamento
                    </button>
                </>} title="Cancelar Transação" onClose={() => setModal(false)}>
                <div className="modalBody" style={{ padding: '10px' }}>
                    <div style={{ 
                        padding: '15px',
                        backgroundColor: '#fff3cd',
                        border: '1px solid #ffeeba',
                        borderRadius: '4px',
                        color: '#856404',
                        marginBottom: '20px',
                        fontSize: '14px'
                    }}>
                        <p style={{ margin: '0', display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: '10px', fontSize: '20px' }}>⚠️</span>
                            <strong>Atenção:</strong> Esta ação irá cancelar a transação e não poderá ser desfeita.
                        </p>
                    </div>
                    
                    <div style={{ 
                        border: '1px solid #e9ecef',
                        borderRadius: '8px',
                        padding: '15px',
                        marginBottom: '20px',
                        backgroundColor: '#f8f9fa'
                    }}>
                        <h4 style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#4f5f9e' }}>Detalhes da Transação</h4>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '14px' }}>
                            <div>
                                <p style={{ color: '#666', margin: '0 0 3px 0', fontSize: '12px' }}><strong>Tipo da Operação</strong></p>
                                <p style={{ margin: '0 0 10px 0', fontWeight: 'bold' }}>{transacao.tipo}</p>
                            </div>
                            <div>
                                <p style={{ color: '#666', margin: '0 0 3px 0', fontSize: '12px' }}><strong>ID</strong></p>
                                <p style={{ margin: '0 0 10px 0', fontWeight: 'bold' }}>{transacao.id}</p>
                            </div>
                            <div>
                                <p style={{ color: '#666', margin: '0 0 3px 0', fontSize: '12px' }}>Data</p>
                                <p style={{ margin: '0 0 10px 0' }}>{transacao.data_completa}</p>
                            </div>
                            <div>
                                <p style={{ color: '#666', margin: '0 0 3px 0', fontSize: '12px' }}>Valor</p>
                                <p style={{ margin: '0 0 10px 0', fontWeight: 'bold', color: '#28a745' }}>R$ {Funcoes.float2Preco(transacao.valorbruto)}</p>
                            </div>
                            {transacao.final_cartao && transacao.tipo_operacao_id === 2 && (
                                <div>
                                    <p style={{ color: '#666', margin: '0 0 3px 0', fontSize: '12px' }}>Final do Cartão</p>
                                    <p style={{ margin: '0 0 10px 0' }}>{transacao.final_cartao}</p>
                                </div>
                            )}
                            {transacao.tipo_operacao_id === 2 && (<div>
                                <p style={{ color: '#666', margin: '0 0 3px 0', fontSize: '12px' }}>Parcelas</p>
                                <p style={{ margin: '0 0 10px 0' }}>{transacao.parcelamento}</p>
                            </div>)}
                        </div>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                            <span style={{ marginRight: '8px' }}>🔐</span> Digite sua senha para confirmar o cancelamento:
                        </label>
                        <Input
                            type="password"
                            value={senha}
                            onChange={e => setSenha(e.target.value)}
                            placeholder="Digite sua senha para confirmar"
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                    </div>
                </div>
            </Modal>
            <SideMenu menuAtivo={4} />

            <div className="body">
                <Header />

                <div className="cardStatement mgDefault">
                    <div className="headerBtn" style={{ marginBottom: '20px' }}>
                        <div>
                            <h1>Detalhes da Transação</h1>
                            <p className="descricao">Informações completas sobre a transação selecionada.</p>
                        </div>
                        {transacao.status_id === 1 && transacao.tipo_operacao_id == 2 ? 
                            (<>
                                <button className="btn" 
                                    onClick={() => setModal(true)}
                                    style={{ 
                                        backgroundColor: '#dc3545', 
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    <span style={{ marginRight: '5px' }}>✖</span> Cancelar Transação
                                </button>
                            </>)
                        : ''}
                    </div>
                    
                    {/* Status da transação em destaque */}
                    <div style={{ 
                        padding: '15px 20px', 
                        marginBottom: '20px',
                        borderRadius: '8px',
                        border: `1px solid ${statusStyles[transacao.status_id]?.borderColor || '#e2e3e5'}`,
                        backgroundColor: statusStyles[transacao.status_id]?.backgroundColor || '#e2e3e5',
                        color: statusStyles[transacao.status_id]?.color || '#383d41',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ 
                                fontSize: '24px', 
                                marginRight: '10px',
                                backgroundColor: 'white',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                                {operationIcons[transacao.tipo] || '🔄'}
                            </span>
                            <div>
                                <h3 style={{ margin: '0', fontWeight: 'bold', fontSize: '18px' }}>{transacao.tipo} - {transacao.status}</h3>
                                <p style={{ margin: '5px 0 0 0', fontSize: '14px' }}>ID: {transacao.id}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <h3 style={{ margin: '0', fontWeight: 'bold', fontSize: '20px' }}>R$ {Funcoes.float2Preco(transacao.valorbruto)}</h3>
                            <p style={{ margin: '5px 0 0 0', fontSize: '14px' }}>{transacao.data_completa}</p>
                        </div>
                    </div>

                    {/* Cards de informações organizados por categorias */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {/* Card de informações principais */}
                        <div className="panel" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                            <div className="panelHeader" style={{ backgroundColor: '#4f5f9e', color: 'white', padding: '15px 20px' }}>
                                <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', color: 'white' }}>
                                    <span style={{ marginRight: '10px' }}>📈</span> Informações da Transação
                                </h3>
                            </div>
                            <div className="panelBody" style={{ padding: '20px' }}>
                                <div style={{ 
                                    display: 'grid', 
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                    gap: '20px'
                                }}>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Cód. Referência</p>
                                        <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.codref}</h3>
                                    </div>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Código da Transação</p>
                                        <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.paymentid}</h3>
                                    </div>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Data e Hora</p>
                                        <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.data_completa}</h3>
                                    </div>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Pagamento</p>
                                        <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.pagamento || '-'}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Card de valores */}
                        <div className="panel" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                            <div className="panelHeader" style={{ backgroundColor: '#28a745', color: 'white', padding: '15px 20px' }}>
                                <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', color: 'white' }}>
                                    <span style={{ marginRight: '10px' }}>💰</span> Valores e Liberação
                                </h3>
                            </div>
                            <div className="panelBody" style={{ padding: '20px' }}>
                                <div style={{ 
                                    display: 'grid', 
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
                                    gap: '20px'
                                }}>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Valor Bruto</p>
                                        <h3 style={{ margin: 0, fontSize: '18px', color: '#28a745', fontWeight: 'bold' }}>R$ {Funcoes.float2Preco(transacao.valorbruto)}</h3>
                                    </div>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Taxas</p>
                                        <h3 style={{ margin: 0, fontSize: '16px', color: '#dc3545' }}>- R$ {Funcoes.float2Preco(transacao.taxas)}</h3>
                                    </div>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Valor Líquido</p>
                                        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>R$ {Funcoes.float2Preco(transacao.liquido)}</h3>
                                    </div>
                                    <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Parcelas</p>
                                        <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.parcelamento}</h3>
                                    </div>
                                    {transacao.status_id == 1 && <div className="info">
                                        <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Liberação do Valor</p>
                                        <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.liberacao}</h3>
                                    </div>}
                                </div>
                            </div>
                        </div>

                        {/* Card de informações do cartão (exibido apenas para transações de crédito ou débito) */}
                        {transacao.tipo_operacao_id === 2 && transacao.final_cartao && (
                            <div className="panel" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                <div className="panelHeader" style={{ backgroundColor: '#17a2b8', color: 'white', padding: '15px 20px' }}>
                                    <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', color: '#fff' }}>
                                        <span style={{ marginRight: '10px' }}>💳</span> Informações do Cartão
                                    </h3>
                                </div>
                                <div className="panelBody" style={{ padding: '20px' }}>
                                    <div style={{ 
                                        display: 'grid', 
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                        gap: '20px'
                                    }}>
                                        <div className="info">
                                            <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Final do Cartão</p>
                                            <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.final_cartao}</h3>
                                        </div>
                                        {transacao.bandeira && (
                                            <div className="info">
                                                <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Bandeira</p>
                                                <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.bandeira_nome}</h3>
                                            </div>
                                        )}
                                        {transacao.nsu && (
                                            <div className="info">
                                                <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>NSU</p>
                                                <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.nsu}</h3>
                                            </div>
                                        )}
                                        {transacao.autorizacao && (
                                            <div className="info">
                                                <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>Autorização</p>
                                                <h3 style={{ margin: 0, fontSize: '16px' }}>{transacao.autorizacao}</h3>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <Link 
                        to="/transacoes" 
                        className="btn btnVoltar"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '10px 20px',
                            backgroundColor: '#4f5f9e',
                            color: 'white',
                            borderRadius: '4px',
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            marginTop: '20px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <span style={{ marginRight: '8px', fontSize: '18px' }}>&#8592;</span> Voltar para Transações
                    </Link>
                </div>
            </div>
        </>
    )
}
